import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { SaveTemplateRequest, UpdateTemplateRequest } from '@ps/survey-utils';

import { TemplateActions } from './template.actions';

@Injectable({ providedIn: 'root' })
export class TemplateActionsFacade {
  private readonly _store = inject(Store);

  public loadTemplates(hasImpersonatedBuyer: boolean, companyId: number): void {
    this._store.dispatch(
      TemplateActions.loadTemplates({ hasImpersonatedBuyer, companyId }),
    );
  }

  public createTemplateFolder(name: string, parentFolderId?: number): void {
    this._store.dispatch(
      TemplateActions.createTemplateFolder({ name, parentFolderId }),
    );
  }

  public loadSaveTargetFolders(
    hasImpersonatedBuyer: boolean,
    companyId: number,
  ): void {
    this._store.dispatch(
      TemplateActions.loadSaveTargetFolders({
        hasImpersonatedBuyer,
        companyId,
      }),
    );
  }

  public saveTemplate(request: SaveTemplateRequest): void {
    this._store.dispatch(TemplateActions.saveTemplate({ request }));
  }

  public updateTemplate(request: UpdateTemplateRequest): void {
    this._store.dispatch(TemplateActions.updateTemplate({ request }));
  }

  public resetCreationState(): void {
    this._store.dispatch(TemplateActions.reset());
  }
}
